const settingCN = {
    SETTING_USER:'用户设置',
    SETTING_COST:'计费中心',
    SETTING_CHANGEINFO:'修改信息',
    SETTING_CHANGEPASSWORD:'修改密码',
    SETTING_COUNT:'账户余额',
    SETTING_DEPOSIT:'充值金额',
    SETTING_RECHARGE:'充 值',
    SETTING_USED:'使用金额',
    SETTING_CONTENT:'标题',
    SETTING_PRICE:'单价',
    SETTING_QUANTITY:'数量',
    SETTING_AMOUNT:'金额',
    SETTING_DAILYLIMIT:'每日额度',
    SETTING_CHECKEDTIME:'查看次数',
    SETTING_TIMELEFT:'剩余次数',
    SETTING_BASICINFO:'基本信息',
    SETTING_USERNAME:'用户名',
    SETTING_NICKNAME:'昵称',
    SETTING_COMPANYINFO:'公司信息',
    SETTING_COMPANYNAME:'公司名称',
    SETTING_LOCATION:'地区',
    SETTING_ZIP:'邮编',
    SETTING_TARGETCOUNTRY:'目标国家',
    SETTING_COMPANYPRODUCT:'公司产品',
    SETTING_ORIGINPASSWORD:'原密码',
    SETTING_NEWPASSWORD:'新密码',
    SETTING_CONFIRMPASSWORD:'确认密码',
    SETTING_PLEASE:'请输入',
    SETTING_TIPS:'提示',
    SETTING_CONFIRMCHANGE:'确认修改',
    SETTING_LOGIN:'登录',
    SETTING_FORGET:'忘记密码',
    SETTING_PASSWORD:'密码',
    SETTING_IDENTIFY:'验证码',
    SETTING_SENDEMAIL:'发送邮件',
    SETTING_SIGNUP:'注册',
    SETTING_NOW_PLAN:'当前套餐',
    SETTING_UPGRADE_PLAN:'升级套餐',
    SETTING_OTHER_FEE:'套餐外花费',
    SETTING_LIMIT:'套餐额度'
}
export default settingCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_setting.js